export default "__VITE_ASSET__BZ1q4s1Z__"